<div class="modal-dialog modal-dialog_settings">
  <button
    type="button"
    class="modal__close"
    aria-label="close"
    (click)="dialogRef.close()"
  ></button>

  <div class="settings">
    <div class="modal__header">
      <div class="modal__title" i18n="@@settings.title">Настройки</div>
    </div>

    <div class="modal-content__content form form_settings">
      <div class="form__group">
        <div class="form__content">
          <span class="form__label" i18n="@@settings.options.disable_animations">Отключить анимации</span>
        </div>
        <label class="switch"
          (click)="toggleDisableAnimations()"
        >
          <input class="switch__control" type="checkbox" id="switch-disableAnimations"
            [disabled]="true"
            [checked]="settingsState.disableAnimations()" />
          <span class="switch__slider"></span>
        </label>
      </div>

      <div class="form__group">
        <div class="form__content">
          <span class="form__label" i18n="@@settings.options.stickers_enabled">Включить стикеры</span>
        </div>
        <label class="switch"
          (click)="toggleStickersEnabled()"
        >
          <input class="switch__control" type="checkbox" id="switch-stickersEnabled"
            [disabled]="true"
            [checked]="settingsState.stickersEnabled()" />
          <span class="switch__slider"></span>
        </label>
      </div>

      <div class="form__group">
        <div class="form__content">
          <span class="form__label" i18n="@@settings.options.stretch_design">Растянуть дизайн</span>
        </div>
        <label class="switch"
          (click)="toggleStretchDesign()"
        >
          <input class="switch__control" type="checkbox" id="switch-streamer"
            [disabled]="true"
            [checked]="settingsState.isStretchDesign()" />
          <span class="switch__slider"></span>
        </label>
      </div>

      <div class="form__group">
        <div class="form__content">
          <span class="form__label" i18n="@@settings.options.crash_two_bets">Две ставки в краше</span>
          <div class="form__description" i18n="@@settings.options.crash_two_bets_desc">Позволяет ставить дополнительную ставку в краше</div>
        </div>

        <label class="switch"
          (click)="toggleCrashTwoBets()"
        >
          <input class="switch__control" type="checkbox" id="switch-streamer"
            [disabled]="true"
            [checked]="settingsState.crashTwoBets()" />
          <span class="switch__slider"></span>
        </label>
      </div>

      <div class="form__group">
        <div class="form__content">
          <span class="form__label" i18n="@@settings.options.streamer_mode">Режим стримера<span class="warning">*</span></span>
          <div class="form__description" i18n="@@settings.options.streamer_mode_desc">Режим стримера скрывает аватарки пользователей, а так же, скрывает отображения никнеймов и сообщений в чате</div>
        </div>
        <label class="switch"
          (click)="toggleStreamerMode()"
        >
          <input class="switch__control" type="checkbox" id="switch-streamer"
            [disabled]="true"
            [checked]="settingsState.streamerMode()" />
          <span class="switch__slider"></span>
        </label>
      </div>
      @defer (on immediate) {
        <shell-sound-toggler />
      }
    </div>
  </div>
</div>